import { OLLIVANDER_PREFIX } from "./AlbusUrlConfigs";
import ApiUtils from "../utils/ApiUtils";
import { IConstituentTemplate } from "../models/PdfTemplatesModels";
import { IFetchConfigRequestParams, IFetchConfigResponse } from "../models/IFetchLoggingConfig";
import { IFeatureConfigRequest, IFeatureConfigResponse } from "../models/IFeatureConfig";
import { IDefaultWorkingHoursRequest, IUpdateDefaultWorkingHoursRequest } from "../models/defaultWorkingHours/IDefaultWorkingHoursRequest";
import { IDefaultWorkingHoursResponse } from "../models/defaultWorkingHours/IDefaultWorkingHoursResponse";

const fetchTemplatesUrl = `${OLLIVANDER_PREFIX}/agents/$doctorId/template?center-id=$centerId&sub-service-type=$doctorType`;
const fetchConfigUrl = `${OLLIVANDER_PREFIX}/config/getConfig`;
const fetchDoctorDefaultWorkingHoursUrl = `${OLLIVANDER_PREFIX}/agents/$doctorId/shifts?center-id=$centerId`;
const updateDoctorDefaultWorkingHoursUrl = `${OLLIVANDER_PREFIX}/agent/$doctorId/shifts`;

export default class OllivanderApis {
    fetchTemplates(doctorId: number, centerId: number, doctorType: string): Promise<IConstituentTemplate> {
        return ApiUtils.apiGetRequest(fetchTemplatesUrl.replace("$doctorId", doctorId.toString()).replace("$centerId", centerId.toString())
            .replace("$doctorType", doctorType))
    }

    fetchLogConfig(doctorId: number): Promise<IFetchConfigResponse> {
        const requestParams: IFetchConfigRequestParams = {
            configName: "OrionVerboseLogs",
            category: "ORION_LOGS",
            searchParams: [
                {
                    "referenceEntity": "DOCTOR",
                    "value": doctorId
                }
            ]
        }
        return ApiUtils.apiPutRequest(fetchConfigUrl, JSON.stringify(requestParams));

    }

    fetchFeatueConfigInfo(params: IFeatureConfigRequest): Promise<IFeatureConfigResponse> {
        return ApiUtils.apiPutRequest(fetchConfigUrl, JSON.stringify(params));
    }

    fetchDoctorDefaultWorkingHours(params: IDefaultWorkingHoursRequest): Promise<IDefaultWorkingHoursResponse[]> {
        const url = fetchDoctorDefaultWorkingHoursUrl.replace("$doctorId", params.doctorId.toString()).replace("$centerId", params.centerId.toString())
        return ApiUtils.apiGetRequest(url);
    }

    updateDoctorDefaultWorkingHours(params: IUpdateDefaultWorkingHoursRequest[], doctorId: number): Promise<IDefaultWorkingHoursResponse[]> {
        const url = updateDoctorDefaultWorkingHoursUrl.replace("$doctorId", doctorId.toString());
        return ApiUtils.apiPostRequest(url, JSON.stringify(params));

    }
}